module.exports = __webpack_public_path__ + "img/logo-white.cd288b98.svg";